module.exports = __webpack_public_path__ + "assets/img/btn-back-5bf4b27f.png";